/**
 * Message type identifiers passed between the service worker and the main app window.
 *
 * !IMPORTANT! - these values are the single source of truth.
 * Both src/sw.ts and src/contexts/NotificationsContext.tsx import from here.
 */
export const ServiceWorkerMessageTypes = {
    NotificationClicked: 'Notification Clicked',
} as const;

export type ServiceWorkerMessageType =
    (typeof ServiceWorkerMessageTypes)[keyof typeof ServiceWorkerMessageTypes];
